module.exports = __webpack_public_path__ + "img/reward.a96e7dd3.svg";